import TextNavBackground from "../components/common/TextNavBackground";
import { apiWrapper } from "../utils/api/apiWrapper";
import { kFAQsURL } from "../utils/constants/apiUrls";
import { GUEST_TOKEN } from "../utils/constants/names";
import { THREE_MONTH_REFRESH_INTERVAL_SECONDS } from "../utils/constants/numbers";
import MarkdownRender from "../components/common/MarkdownRender";
import { customStaticSeoConfig } from "../utils/helpers/helpers";
import { TERMS_AND_CONDITIONS_URL } from "../utils/constants/websiteUrls";
import { TabNoData } from "../components/common/NoData";

const FAQs = ({ faqs }) => {
  const { faqs: faqsInfo } = faqs;

  const url = TERMS_AND_CONDITIONS_URL;

  return (
    <>
      {customStaticSeoConfig("FAQs")}
      <TextNavBackground title="FAQs" />

      {faqsInfo === "" && <TabNoData />}

      {faqsInfo !== "" && (
        <MarkdownRender
          title={"Asante Kotoko SC FAQs"}
          caption={
            "Frequently Asked Questions about the Asante Kotoko website and app."
          }
          url={url}
          markdownData={faqsInfo}
        />
      )}
    </>
  );
};

export default FAQs;

export const getStaticProps = async (context) => {
  const token = process.env.GUSET_USER_TOKEN
    ? process.env.GUSET_USER_TOKEN
    : GUEST_TOKEN;

  const faqs = await apiWrapper.get(kFAQsURL, token);

  return {
    props: {
      faqs: faqs?.data,
    },
    revalidate: THREE_MONTH_REFRESH_INTERVAL_SECONDS,
  };
};
